import get from 'lodash/get';

const getFeatureFlags = state => get(state, 'dashboard.featureFlag', {});

export default getFeatureFlags;
